import { api as axios } from '@/plugins/axios.js';

export const authenticate = async (username, password) => {
  const config = {
    method: 'post',
    url: '/v1/token/',
    data: { username, password },
  };
  const { data } = await axios(config);
  return data;
};

export const editProfile = async (token,id, form) => {
  const config = {
    method: 'patch',
    url: `/v2/user/${id}/`, 
    headers: {
      'Authorization': 'Bearer ' + token,
    },
    data: form,
  };
  const { data } = await axios(config);
  return data;
};

export const changePassword = async (token, form) => {
  const config = {
    method: 'post',
    url: '/v2/profile/change-password/',
    headers: {
      'Authorization': 'Bearer ' + token,
    },
    data: form,
  };
  const { data } = await axios(config);
  return data;
};
